import { useEffect, useState } from 'react'
import { useAtom } from 'jotai'
import { cartItemsAtom } from '@!/atoms/cartItemsAtom'
import { userUsableCoinsAtom } from '@!/atoms/userInfoAtom'
import { monthlyCoursesAtom } from '@!/atoms/paymentAtom'
import { isBlank } from '@!/Util'
import { calculatePrice } from '@!/Store/Common/util/calculatePrice'

// 不足コイン数とおすすめ月額コース名を返すカスタムフック
export function useLessCoinsInfo() {
  const [cartItems] = useAtom(cartItemsAtom)
  const [userUsableCoins] = useAtom(userUsableCoinsAtom)
  const [monthlyCourses] = useAtom(monthlyCoursesAtom)
  const [lessCoins, setLessCoins] = useState(0)
  const [recommendedCourseName, setRecommendedCourseName] = useState(null)

  // カートの合計金額に対して不足しているコイン数を計算
  useEffect(() => {
    if (isBlank(cartItems)) return setLessCoins(0)
    const cartTotalPrice = calculatePrice(cartItems)
    const lessCoinsValue = Math.max(cartTotalPrice - userUsableCoins, 0)
    setLessCoins(lessCoinsValue)
  }, [cartItems, userUsableCoins])

  useEffect(() => {
    if (isBlank(monthlyCourses) || lessCoins <= 0) {
      setRecommendedCourseName(null)
      return
    }

    // 不足コイン数より多くチャージできる月額コースをおすすめ表示
    const pickedCourse = monthlyCourses.find((course) => course.coin_count > lessCoins)
    // 登録済み・解約予約済みの場合はおすすめ表示しない
    const recommendedName = isBlank(pickedCourse) || pickedCourse.is_registered || pickedCourse.is_cancel_reserved ? null : pickedCourse.name
    setRecommendedCourseName(recommendedName)
  }, [lessCoins, monthlyCourses])

  return { lessCoins, recommendedCourseName }
}
